import { Maximize2, Minimize2, PanelRightClose } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useAgentPanel } from '@/context/agent-panel-context'
import { cn } from '@/lib/utils'

type AgentPanelButtonProps = {
  className?: string
}

/** Restores the agent column when it is hidden (`Minimize2`). */
export function AgentPanelToggleButton({ className }: AgentPanelButtonProps) {
  const { available, agentCollapsed, showAgent } = useAgentPanel()

  if (!available || !agentCollapsed) {
    return null
  }

  return (
    <Button
      type="button"
      variant="ghostToolbar"
      size="iconSm"
      className={cn(className)}
      onClick={() => void showAgent()}
      aria-label="Show agent"
      title="Show agent"
    >
      <Minimize2 className="h-4 w-4" aria-hidden />
    </Button>
  )
}

/** Hides the agent column so the page can expand (`Maximize2`). */
export function AgentPanelMaximizeButton({ className }: AgentPanelButtonProps) {
  const { available, agentCollapsed, pageCollapsed, collapseAgent } = useAgentPanel()

  if (!available || agentCollapsed || pageCollapsed) {
    return null
  }

  return (
    <Button
      type="button"
      variant="ghostToolbar"
      size="iconSm"
      className={cn(className)}
      onClick={() => void collapseAgent()}
      aria-label="Expand page"
      title="Expand page"
    >
      <Maximize2 className="h-4 w-4" aria-hidden />
    </Button>
  )
}

/** Collapses the page column so the agent is full width (`PanelRightClose`). */
export function AgentPanelCloseButton({ className }: AgentPanelButtonProps) {
  const { available, pageCollapsed, collapsePage } = useAgentPanel()

  if (!available || pageCollapsed) {
    return null
  }

  return (
    <Button
      type="button"
      variant="ghostToolbar"
      size="iconSm"
      className={cn(className)}
      onClick={() => void collapsePage()}
      aria-label="Full screen agent"
      title="Full screen agent"
    >
      <PanelRightClose className="h-4 w-4" aria-hidden />
    </Button>
  )
}
